import { Style } from "gc-types";
import { ErrorObject } from "ajv";

export type SearchAppQuerySortField = "entity_id" | "position" | "price";
export type SearchAppQuerySortDirection = "desc" | "asc";

export enum SortingBy {
  Newest = "new",
  Featured = "featured",
  LowestPrice = "low-price",
  HighestPrice = "high-price"
}

type SortingOrderToSearchAppQuerySorting = {
  [key in SortingBy]: [SearchAppQuerySortField, SearchAppQuerySortDirection];
};
export const StylesSorting: SortingOrderToSearchAppQuerySorting = {
  [SortingBy.Newest]: ["entity_id", "desc"],
  [SortingBy.Featured]: ["position", "asc"],
  [SortingBy.LowestPrice]: ["price", "asc"],
  [SortingBy.HighestPrice]: ["price", "desc"]
};

export type SearchAppQueryFlags =
  | "check_quantity"
  | "on_demand"
  | "subscription"
  | "subscription_available_now"
  | "no_ex_rental"
  | "ex_rental_only"
  | "sale"
  | "rental"
  | "all_style_images"
  | "unknown_flag";

export interface SearchAppQuery {
  text: string;
  filters: QueryFilters;
  date_range?: string;
  style_codes?: string[];
  postcode?: string;
  field: string;
  flags: SearchAppQueryFlags[];
  paging: {
    limit: number;
    offset: number;
  };
  sorting?: [[SearchAppQuerySortField, SearchAppQuerySortDirection]];
  storefront?: string;
}

export interface QueryFilters {
  [filterCode: string]: string[][];
}

export interface ResultFilters {
  [key: string]: {
    [key: string]: number;
  };
}

export interface SearchAppResult {
  data: any[];
  count: number;
  filters: ResultFilters;
  impossible_delivery_date: any;
}

export interface CatalogueAppResult extends SearchAppResult {
  html: string;
  page_records_count: number;
  invalidStyles: InvalidStyle[];
}

export interface CatalogueFilterQuery extends SearchAppQuery {
  postcode: string;
  date_range: string;
  storefront: string;
}

export interface DeliveryCalendarQuery {
  postcode?: string;
}

export interface DeliveryCalendarResult {
  available_delivery_dates: string[];
}

export interface SearchAppError {
  error: any;
}

export interface InvalidStyle {
  style: Style;
  errors: ErrorObject[];
}

export interface FilterStylesResult {
  validStyles: Style[];
  invalidStyles: InvalidStyle[];
}

export interface AttributeFilter {
  code: string;
  label: string;
  options: AttributeFilterOption[];
}

export interface AttributeFilterItemProps {
  attributeFilter: AttributeFilter;
}

export interface AttributeFilterOption {
  label: string;
  value: string;
}

export interface CatalogueScopeFilters {
  flags: SearchAppQueryFlags[];
  searchText: string;
  styleCodes: string[] | undefined;
  categories: string[][];
  availableDesignations: CollectionDesignation[];
}

export enum CollectionDesignation {
  All = "all",
  AvailableToBuy = "available-to-buy",
  OnDemand = "on-demand",
  Subscription = "subscription"
}

export interface CollectionFilter {
  collectionDesignation: CollectionDesignation;
  sorting: SortingBy;
}

export interface CatalogueReviews {
  count: number;
  averageRating: number;
  reviews: ReviewData[];
}

export interface ReviewData {
  date: string;
  datetime: string;
  customer: string;
  text: string;
  title: string;
  product: string;
  url: string;
  rating: number;
  location?: string;
}
